<template>
  <div class="green lighten-4">
    <v-container style="max-width: 1800px">
      <v-btn
        class="white mr-2"
        active-class="white--text primary"
        link
        :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/customer/market`"
        outlined
        elevation="0"
      >{{ $t('market.market_customer') }}</v-btn>
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/customer/project`"
        active-class="white--text primary"
        outlined
        elevation="0"
      >{{ $t('project.project_customer') }}</v-btn>
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/market/${$route.params.marketId}/customer/companion`"
        active-class="white--text primary"
        outlined
        elevation="0"
      >{{ $t('market.companion_project_customer') }}</v-btn>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style lang="scss" scoped>
.tool-bar {
  background-color: rgb(233, 249, 238);
  border: 1px solid rgb(221, 242, 228);
}
</style>
